<template>
  <div class="post relative" id="post" @wheel.stop>
    <blogWrappers :post="true" />
    <div class="pt-37.5 w-full flex flex-col slide min-h-screen">
      <div class="pr-23.5 pl-40 header flex flex-col-reverse">
        <div class="flex flex-col">
          <div class="flex justify-between">
            <div class="title w-112">
              <h2 class="font-light fz-35" style="color: #ff2e53">
                {{ text.title }}
              </h2>
            </div>
            <div class="share flex-shrink-0 flex justify-end">
              <img src="@/assets/images/share.svg" class="w-12.5 h-12.5" alt="" />
            </div>
          </div>
          <div class="header-text mt-12.5">
            <p class="fz-201 text-white mb-[5.3125rem]">
              {{ text.headerText }}
            </p>
            <div class="flex justify-between items-center">
              <p
                class="date fz-10"
                style="letter-spacing: 0.3rem; color: #6e758d"
              >
                {{ text.date }}
              </p>
              <div class="tags flex gap-2">
                <p
                    v-for="tag in text.tags"
                  class="tag w-full cursor-pointer whitespace-nowrap font-semibold fz-13 uppercase py-2.5 px-5 rounded-full border"
                >
                  {{ tags[tag] }}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="article-content flex flex-col gap-25 my-25">
        <div v-for="contentPart in Object.entries(text.content)" :key="contentPart[0]" >
          <imageElement v-if="contentPart[0].includes('imageElement')" :source="postId + '/' + contentPart[1].source"/>
          <div class="px-23.5" v-if="contentPart[0].includes('doubleSlider')">
            <slider

                :slides-container-classes="'mb-7.75 gap-5'"
                :similar-slides="true"
                :pagination="true"
                pagination-container-classes="gap-5"
            >
              <template v-slot:slides>
                <div
                    class="slider-slide w-145 flex flex-col"
                    v-for="item in contentPart[1].sources"
                    :key="item"
                >
                  <img
                      :src="
              require('@/assets/images/blog/' + this.postId + '/slider/' + item)
            "
                      class="h-100 w-145"
                      style="background: rgba(110, 117, 141, 0.2)"
                      alt=""
                  />
                </div>
              </template>
              <template v-slot:pagination>
                <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
              </template>
            </slider>
          </div>

          <postSection v-else-if="contentPart[0].includes('postSection')" :content="contentPart[1]"/>
          <imageWithMark v-else-if="contentPart[0].includes('imageWithMark')" :source="postId + '/' + contentPart[1].source" :marks="contentPart[1].marks"/>
        </div>
      </div>


      <div class="flex flex-col">
        <a
            href="#post"
            class="w-max to-top ml-38.5 transform transition cursor-pointer"
        >
          <svg
              width="14"
              class="transform transition duration-800 rotate-180"
              height="13"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 6L7 12L13 6" stroke-linejoin="round" />
            <path d="M6.99998 0V12" stroke-linejoin="round" />
          </svg>
          <p
              class="fz-10 uppercase mt-2.5"
              style="letter-spacing: 0.3em"
          >
            {{ all.back }}
          </p>
        </a>

<!--        <div-->
<!--            class="next cursor-pointer w-full h-55 relative"-->
<!--            v-if="text.nextTitle"-->
<!--            @click="$emit('nextPost')"-->
<!--        >-->
<!--          &lt;!&ndash; Background start &ndash;&gt;-->
<!--          <div class="absolute w-full h-full shadow z-10"></div>-->
<!--          <img-->
<!--              class="w-full h-full"-->
<!--              :src="require('@/assets/images/blog/' + postId + '/next.png')"-->
<!--              alt=""-->
<!--          />-->
<!--          <div class="line absolute bottom-0 h-2"></div>-->
<!--          &lt;!&ndash; Background end &ndash;&gt;-->
<!--          <div class="content absolute z-20 bottom-23 left-38.5">-->
<!--            <p class="next-post-title fz-13 uppercase font-semibold mb-2.5">-->
<!--              {{ all.next }}-->
<!--            </p>-->
<!--            <h3 class="w-115" style="font-size: 1.5625rem;">{{ text.nextTitle }}</h3>-->
<!--          </div>-->
<!--        </div>-->
      </div>

    </div>
  </div>
</template>

<script>
import imageElement from "@/components/tablet/blog/postElements/imageElement";
import imageWithMark from "@/components/tablet/blog/postElements/imageWithMark";
import miniMarkedList from "@/components/tablet/blog/postElements/miniMarkedList";
import markedList from "@/components/tablet/blog/postElements/markedList";
import numberedList from "@/components/tablet/blog/postElements/numberedList";
import postSection from "@/components/tablet/blog/postElements/postSection";
import sectionHeader from "@/components/tablet/blog/postElements/sectionHeader";
import textElement from "@/components/tablet/blog/postElements/textElement";
import blogWrappers from "./blogWrappers";
import slider from "../reuseable/slider";
import {mapState} from "vuex";

export default {
  name: "post",
  emits: ["nextPost"],
  components: {
    blogWrappers,
    slider,
    imageElement,
    imageWithMark,
    miniMarkedList,
    markedList,
    numberedList,
    postSection,
    sectionHeader,
    textElement
  },
  computed: {
    ...mapState(['lang', 'postId']),
    text() {
      return this.all.posts[this.postId];
    },
    tags(){
      return require("@/assets/text/blog/posts/" + this.lang + ".json").tags;
    },
    all() {
      return require("@/assets/text/blog/posts/" + this.lang + ".json");
    },
  },
};
</script>

<style lang="scss" scoped>
// Next post start
.next {
  margin-top: 9rem;
  overflow: hidden;
  height: 18.75rem;
  transition: all linear 0.3s;
  .line {
    transition: all linear 0.3s;
    background: #ff2e53;
    width: 100%;
    z-index: 11;
  }
  img.w-full {
    transition: all linear 0.3s;
  }
  .shadow {
    transition: all linear 0.3s;
    background: rgba(0, 0, 0, 0.8);
  }
}
// Next post end

//Back to top button start
.to-top {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: rgba(151, 163, 203, 0.6);
    }
  }
  p {
    transition: all linear 0.3s;
    color: rgba(151, 163, 203, 0.6);
  }
}
.to-top:hover {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: white;
    }
  }
  p {
    transition: all linear 0.3s;
    color: white;
  }
}
//Back to top button end
</style>
